import Vue from 'vue';
import VueRouter from 'vue-router';
import cookie from '../common/cookie.js';
import store from '../store';
import list from './business';

// login
const Login = (resolve) => require(['@/components/Login'], resolve);
// 公众号进入的登陆页面
const Home = (resolve) => require(['@/components/Home'], resolve);
// 首页内容
const HomeDashboard = (resolve) => require(['@/components/Home/HomeDashboard.vue'], resolve);
// 酒店搜索页面
const SearchHotel = (resolve) => require(['@/components/Home/searchHotel.vue'], resolve);
// 账号管理
const Manager = (resolve) => require(['@/components/Home/manager.vue'], resolve);
// 选择酒店后的页面
const HotelManagerPage = (resolve) => require(['@/components/Home/hotel-manager-page.vue'], resolve);
const HomeNoPaid = (resolve) => require(['@/components/Home/HomeNoPaid.vue'], resolve);

/************************************   订单管理---模块   *****************************************/
// 订单列表
const Order = (resolve) => require(['@/components/Order'], resolve);
// 更换房间-长租
const ChangeRoom_long = (resolve) => require(['@/components/Order/ChangeRoom_long.vue'], resolve);
//订单详情
const Details = (resolve) => require(['@/components/Order/Details.vue'], resolve);
// 租赁信息-长租
const RentInfo_long = (resolve) => require(['@/components/Order/RentInfo_long.vue'], resolve);
// 租赁信息-添加生活、房租账单
const Add_bill = (resolve) => require(['@/components/Order/Long_Sort/add_bill.vue'], resolve);
// 耕作操作
const More = (resolve) => require(['@/components/Order/More.vue'], resolve);
// 修改订单
const Amend = (resolve) => require(['@/components/Order/Amend.vue'], resolve);
// 订单详情-房费收入详情
const RoomePricePage = (resolve) => require(['@/components/Order/pages/roomPrice-page.vue'], resolve);
// 订单详情-押金详情
const depositCutPage = (resolve) => require(['@/components/Order/pages/depositCut-page.vue'], resolve);
// 生活费用设置
const PaySet = (resolve) => require(['@/components/Order/pages/paySet-page.vue'], resolve);
// 录入车牌
const carNo = (resolve) => require(['@/components/Order/pages/carNo-page.vue'], resolve);

/************************************   报表下载---模块   *****************************************/
// 报表下载-index
const Report = (resolve) => require(['@/components/Report/index.vue'], resolve);

/************************************   房态管理---模块   *****************************************/
// 房间状态-公寓类型
const Apartment = (resolve) => require(['@/components/State/Apartment'], resolve);
// 房间状态
const State = (resolve) => require(['@/components/State'], resolve);
const OwnerOrderDetails = (resolve) => require(['@/components/State/owner-order-details.vue'], resolve);
const OwnerOrder = (resolve) => require(['@/components/State/owner-order.vue'], resolve);
// 房间支出
const RoomOut = (resolve) => require(['@/components/State/room-out'], resolve);
// 房态-查房
const StateCheck = (resolve) => require(['@/components/State/StateCheck.vue'], resolve);
const StateToday = (resolve) => require(['@/components/State/StateToday.vue'], resolve);
// 房间状态-cooper
const StateTodayCooper = (resolve) => require(['@/components/State/StateTodayCooper.vue'], resolve);
const StateTodayOwner = (resolve) => require(['@/components/State/StateTodayOwner.vue'], resolve);

/************************************   房价管理---模块   *****************************************/
// 房价明细ive
const PriceDetail = (resolve) => require(['@/components/Price/PriceDailyMouth.vue'], resolve);
// 房价
const Price = (resolve) => require(['@/components/Price/Price.vue'], resolve);

/************************************   房源管理---模块   *****************************************/
// 房源管理-首页
const Source = (resolve) => require(['@/components/Source/Source.vue'], resolve);
// 房型管理（基础，产品，房间数量）
const ScaleManage = (resolve) => require(['@/components/Source/ScaleManage.vue'], resolve);
// 新增或修改-产品房型
const AddOrEditPro = (resolve) => require(['@/components/Source/addOrEditPro.vue'], resolve);
// 新增或修改-产品房型-添加费用
const AddPrice = (resolve) => require(['@/components/Source/addPrice.vue'], resolve);
// 新增或修改-酒店信息
const AddOrEditHotel = (resolve) => require(['@/components/Source/addOrEditHotel.vue'], resolve);
// 新增或修改-酒店信息-系统续费
const ContinuePay = (resolve) => require(['@/components/Source/continuePay.vue'], resolve);
// 新增或修改-酒店信息-系统续费
const ContinuePayChoose = (resolve) => require(['@/components/Source/continuePayChoose.vue'], resolve);
// 新增或修改-酒店信息-系统续费
const ContinuePayPage = (resolve) => require(['@/components/Source/continuePay-page.vue'], resolve);
// 新增默认保洁项目
const NormalProject = (resolve) => require(['@/components/Source/normal-project.vue'], resolve);
// 酒店信息-上传图片
const UploadHotelPic = (resolve) => require(['@/components/Source/uploadHotelPic.vue'], resolve);

/************************************   房间管理---模块   *****************************************/
// 房间管理-首页
const RoomManage = (resolve) => require(['@/components/RoomManage/index.vue'], resolve);
// 添加房间
const AddRooms = (resolve) => require(['@/components/RoomManage/addRooms.vue'], resolve);
// 手动分房
// 日租-订单同步
const OrderDay = (resolve) => require(['@/components/Order/orderday.vue'], resolve);
// // 长租-订单同步
const OrderMonth = (resolve) => require(['@/components/Order/ordermonth.vue'], resolve);

/************************************   财务管理---模块   *****************************************/
// 财务管理
const Finance = (resolve) => require(['@/components/Finance/Finance.vue'], resolve);

/************************************   财务管理---业主---模块   *****************************************/
// 业主-财务管理
const OwnerFinance = (resolve) => require(['@/components/Finance/owner-finance.vue'], resolve);
// 业主-财务管理-收款详情(房间)
const OwnerFinanceRooms = (resolve) => require(['@/components/Finance/owner-finance-rooms.vue'], resolve);
// 业主-财务管理-房间详情
const OwnerFinanceDetails = (resolve) => require(['@/components/Finance/owner-finance-details.vue'], resolve);
// 业主-财务管理-房间详情-日常消耗品、保洁人工费
const OwnerFinanceDailyLife = (resolve) => require(['@/components/Finance/owner-finance-daily-life.vue'], resolve);

/************************************   财务管理---业主结算---模块   *****************************************/
// 业主结算-首页
const OwnerSettle = (resolve) => require(['@/components/Finance/owner-settle-finance-persons.vue'], resolve);
// 业主结算-首页
const OwnerSettlePerson = (resolve) => require(['@/components/Finance/owner-settle-finance-person.vue'], resolve);
// 业主结算-详情
const OwnerSettleDetail = (resolve) => require(['@/components/Finance/owner-settle-finance-detail.vue'], resolve);

/************************************   乱的---模块（以前的）   *****************************************/
// 订单详情（财务管理）
const OrderDetail = (resolve) => require(['@/components/Finance/OrderDetail.vue'], resolve);
// 账单详情
const MoneyDetail = (resolve) => require(['@/components/Finance/MoneyDetail.vue'], resolve);
// 出账记录
const OutRecord = (resolve) => require(['@/components/Finance/outRecord.vue'], resolve);
// 办理入住
const DealLive = (resolve) => require(['@/components/Order/dealLive.vue'], resolve);
// 同步订单直接办理入住
const OrderLive = (resolve) => require(['@/components/Order/orderLive.vue'], resolve);
// 办理入住-长租
const DealLive_long = (resolve) => require(['@/components/Order/DealLive_long.vue'], resolve);
// 直连管理
const Housetype = (resolve) => require(['@/components/Housetype/Housetype.vue'], resolve);
// 直连管理-关联外部平台
const Relation = (resolve) => require(['@/components/Housetype/relation.vue'], resolve);
// 直连管理-关联外部平台
const OtaState = (resolve) => require(['@/components/Housetype/pages/otaState-page.vue'], resolve);
// 功能更新
const Reset = (resolve) => require(['@/components/Reset/Reset.vue'], resolve);
// 集中抄表
const Focus = (resolve) => require(['@/components/Focus/Focus.vue'], resolve);
// 未收账单
const OrderLong = (resolve) => require(['@/components/Bill/OrderLong.vue'], resolve);
// 功能更新
const ResetInfo = (resolve) => require(['@/components/Reset/ResetInfo.vue'], resolve);
// 公安系统
const Police = (resolve) => require(['@/components/Police/Police.vue'], resolve);
// 门店会员
const HotelMember = (resolve) => require(['@/components/HotelMember/HotelMember.vue'], resolve);
// 门店会员-会员详情
const MemberDetail = (resolve) => require(['@/components/HotelMember/MemberDetail.vue'], resolve);
// 门店会员-会员设置
const MemberSet = (resolve) => require(['@/components/HotelMember/MemberSet.vue'], resolve);
// 月租-房费账单
const RoomFee = (resolve) => require(['@/components/Order/RoomFee.vue'], resolve);
// 月租-生活账单
const LifeFee = (resolve) => require(['@/components/Order/LifeFee.vue'], resolve);
// 月租-生活账单明细
const LifeFeetrans = (resolve) => require(['@/components/Order/LifeFeetrans.vue'], resolve);
// order-添加入住人
const AddPerson = (resolve) => require(['@/components/Order/AddPerson.vue'], resolve);
// 生活账单详情-X
const LifeFeeD = (resolve) => require(['@/components/Order/LifeFeeD.vue'], resolve);
// 生活账单详情
const EditLifeFee = (resolve) => require(['@/components/Order/EditLife.vue'], resolve);
// 房费账单详情
const RoomFeeD = (resolve) => require(['@/components/Order/RoomFeeD.vue'], resolve);
// 房费账单详情-收款码
const Roomcode = (resolve) => require(['@/components/Order/pages/roomCode-page.vue'], resolve);
// order长租-退租
const BackRent = (resolve) => require(['@/components/Order/BackRent.vue'], resolve);
// 房东换房型(未办理入住)
const FdChange = (resolve) => require(['@/components/Order/FdChange.vue'], resolve);
// 首页-散客入住
const QuickSplit = (resolve) => require(['@/components/Split/QuickSplit.vue'], resolve);
// 首页-散客入住-办理入住
const QuickLive = (resolve) => require(['@/components/Split/QuickLive.vue'], resolve);
// 首页-散客入住-办理入住-哎哟有房收款
const QuickLiveOnline = (resolve) => require(['@/components/Split/QuickLiveOnline.vue'], resolve);
// 退租清算
const RentCount = (resolve) => require(['@/components/Order/RentCount.vue'], resolve);
// 续租
const Renew = (resolve) => require(['@/components/Order/Renew.vue'], resolve);

const Lock = (resolve) => require(['@/components/Lock/Lock.vue'], resolve);
// order-换表
const ChangeWatch = (resolve) => require(['@/components/Order/ChangeWatch.vue'], resolve);
// order-电费记录
const EleRecord = (resolve) => require(['@/components/Order/EleRecord.vue'], resolve);
// order-电费管理
const EleManage = (resolve) => require(['@/components/Order/EleManage.vue'], resolve);
// order-用电统计
const EleTotal = (resolve) => require(['@/components/Order/EleTotal.vue'], resolve);

/************************************   设施管理---模块   *****************************************/
// 设施管理-首页
const RoomDev = (resolve) => require(['@/components/RoomDev/index.vue'], resolve);
// 设施管理-选择酒店、房型设施
const ChooseDev = (resolve) => require(['@/components/RoomDev/chooseDev.vue'], resolve);

/************************************   二房东---模块   *****************************************/
//二房东 --index
const Business = (resolve) => require(['@/components/business/index.vue'], resolve);
//二房东 -- 新增 add
const BusinessAdd = (resolve) => require(['@/components/business/pages/add.vue'], resolve);
//二房东 -- 选择房间
const BusinessAllRooms = (resolve) => require(['@/components/business/pages/allRooms.vue'], resolve);
//二房东 -- 单位详情 & 编辑
const BusinessDetails = (resolve) => require(['@/components/business/pages/details.vue'], resolve);
//二房东 -- 根据Id获取订单
const BusinessOrder = (resolve) => require(['@/components/business/pages/order.vue'], resolve);
// 新增订单
const BusinessAddOrder = (resolve) => require(['@/components/business/pages/add-order.vue'], resolve);
// 二房东 -- 查看账单
const Check_bill_two = (resolve) => require(['@/components/business/pages/check_bill_two.vue'], resolve);
// 房间状态-二房东
const StateToday_two = (resolve) => require(['@/components/business/pages/stateToday_two.vue'], resolve);
// 租赁信息-二房东
const RentInfo_two = (resolve) => require(['@/components/business/pages/rentInfo_two.vue'], resolve);
// 租赁信息-订单详情页
const Details_two = (resolve) => require(['@/components/Order/details_two.vue'], resolve);
// 租赁信息-退租
const RentCount_two = (resolve) => require(['@/components/Order/rentCount_two.vue'], resolve);
// 二房东 -- 添加生活、房费账单
const AddBillTwo = (resolve) => require(['@/components/business/pages/add_bill_two.vue'], resolve);
// 二房东 -- 单位详情页面
const UnitDetails = (resolve) => require(['@/components/business/pages/unit_details.vue'], resolve);
// 交账充值
const HandCharge = (resolve) => require(['@/components/finance/HandCharge.vue'], resolve);
// 交账充值记录
const HandChargeRecord = (resolve) => require(['@/components/finance/HandChargeRecord.vue'], resolve);
//总账单 --index
const AllBill = (resolve) => require(['@/components/allBill/index.vue'], resolve);

/************************************   开票信息---模块   *****************************************/
// 开票信息-首页
const InvoiceModel = (resolve) => require(['@/components/invoiceModel/index.vue'], resolve);
// 开票详情
const Invoice = (resolve) => require(['@/components/invoice/index.vue'], resolve);

/************************************   员工管理---模块   *****************************************/
// 员工管理-首页
const Staff = (resolve) => require(['@/components/Staff/index.vue'], resolve);
// 添加员工
const AddStaff = (resolve) => require(['@/components/Staff/add-staff.vue'], resolve);
// 员工审核列表
const StaffApply = (resolve) => require(['@/components/Staff/staff-apply.vue'], resolve);
// 员工信息
const StaffInfo = (resolve) => require(['@/components/Staff/staff-info.vue'], resolve);
// 员工任务统计-清洁、保洁订单
const Cleaningtask = (resolve) => require(['@/components/Staff/cleaning-task.vue'], resolve);

/************************************   酒店审核---模块   *****************************************/
// 酒店审核列表-首页
const Join = (resolve) => require(['@/components/Join/index.vue'], resolve);
// 酒店审核
const HotelApply = (resolve) => require(['@/components/Join/hotel-apply.vue'], resolve);
// 添加设备
const AddEquipment = (resolve) => require(['@/components/Join/add-equipment.vue'], resolve);
// 编辑申请单
const EditOrSeeApply = (resolve) => require(['@/components/Join/edit-or-see-apply.vue'], resolve);
// 软件使用
const SoftUse = (resolve) => require(['@/components/Join/soft-use.vue'], resolve);

/************************************   智能设备---模块   *****************************************/
// 智能设备-首页
const Eequipment = (resolve) => require(['@/components/Eequip/index.vue'], resolve);
// 新建申请
const AddApply = (resolve) => require(['@/components/Eequip/add-apply.vue'], resolve);
// 支付方式页面
const PayPage = (resolve) => require(['@/components/Eequip/pay-page.vue'], resolve);

/************************************  业务员、业务经理---模块   *****************************************/
// 客户管理-首页
const CustomerManagement = (resolve) => require(['@/components/BusinessModule/CustomerManagement/index.vue'], resolve);
// 业务提成-首页
const BusinessCommission = (resolve) => require(['@/components/BusinessModule/BusinessCommission/index.vue'], resolve);
//业务提成详情
const CommissionDetail = (resolve) => require(['@/components/BusinessModule/BusinessCommission/commissionDetail.vue'], resolve);
// 部门管理-首页
const DepartManagement = (resolve) => require(['@/components/BusinessModule/DepartManagement/index.vue'], resolve);
// 部门管理-员工部门管理
const StaffDepartManagement = (resolve) => require(['@/components/BusinessModule/DepartManagement/staffDepart-management.vue'], resolve);
// 部门管理-员工管理
const StaffManagement = (resolve) => require(['@/components/BusinessModule/DepartManagement/staff-management.vue'], resolve);
// 部门管理-添加人员-二维码
const AddDepartStaff = (resolve) => require(['@/components/BusinessModule/DepartManagement/add-departStaff.vue'], resolve);
// 业务员-首页
const BusinessManager = (resolve) => require(['@/components/BusinessModule/BusinessManager/index.vue'], resolve);

/************************************  财务模块---模块   *****************************************/
// 财务登陆-首页
const FinancePay = (resolve) => require(['@/components/FinancePayModule/index.vue'], resolve);
// 财务详情
const FinanceDetail = (resolve) => require(['@/components/FinancePayModule/finance-detail.vue'], resolve);

/************************************  黑名单模块---模块    *****************************************/
// 黑名单模块-首页
const BlackList = (resolve) => require(['@/components/BlackList/index.vue'], resolve);

/************************************  保洁成本设置---模块   *****************************************/
// 设施管理-首页
const Cleaning = (resolve) => require(['@/components/Cleaning/index.vue'], resolve);

/************************************  商品设置---模块   *****************************************/
// 设施管理-首页
const Goods = (resolve) => require(['@/components/Goods/index.vue'], resolve);

/************************************  二级商户---模块   *****************************************/
// 二级商户-首页
// const Merchant = (resolve) => require(['@/components/Merchant/index.vue'], resolve);
const Merchant = (resolve) => require(['@/components/Merchant/newMerchantPage/newMerchantPage.vue'], resolve);
// 新增or编辑
const MerchantAddOrEdit = (resolve) => require(['@/components/Merchant/addOrEdit.vue'], resolve);

/************************************  异常房间---模块   *****************************************/
// 异常房间-首页
const ErrorRoom = (resolve) => require(['@/components/ErrorRoom/index.vue'], resolve);
// 新增or编辑
const ErrorRooms = (resolve) => require(['@/components/ErrorRoom/errorRooms.vue'], resolve);

/************************************  收款账户---模块   *****************************************/
const PayeeAccount = (resolve) => require(['@/components/PayeeAccount/index.vue'], resolve);
const PayeeDetail = (resolve) => require(['@/components/PayeeAccount/payeeDetail.vue'], resolve);
const PayeeDetailPage = (resolve) => require(['@/components/PayeeAccount/payeeDetailPage.vue'], resolve);
Vue.use(VueRouter);

let router = new VueRouter({
    mode: 'history', // html的history模式，默认是hash模式（路由不带#号）
    routes: [
        {
            path: '/login',
            name: '登录',
            component: Login
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            redirect: '/dashboard', // 重定向
            children: [
                ...list,
                {
                    path: '/dashboard',
                    component: HomeDashboard,
                    name: '首页',
                    menuShow: true
                },
                {
                    path: '/homeNoPaid',
                    component: HomeNoPaid,
                    name: 'HomeNoPaid',
                    menuShow: true
                },
                {
                    path: '/payeeAccount',
                    component: PayeeAccount,
                    name: 'PayeeAccount',
                    menuShow: true
                },
                {
                    path: '/payeeDetail',
                    component: PayeeDetail,
                    name: 'PayeeDetail',
                    menuShow: true
                },
                {
                    path: '/payeeDetailPage',
                    component: PayeeDetailPage,
                    name: 'PayeeDetailPage',
                    menuShow: true
                },
                {
                    path: '/searchHotel',
                    component: SearchHotel,
                    name: 'SearchHotel',
                    menuShow: true
                },
                {
                    path: '/manager',
                    component: Manager,
                    name: 'Manager',
                    menuShow: true
                },
                {
                    path: '/hotel-manager-page',
                    component: HotelManagerPage,
                    name: 'HotelManagerPage',
                    menuShow: true
                },
                {
                    path: '/order', //订单管理
                    name: '订单',
                    component: Order,
                    menuShow: false,
                    meta: {
                        requireAuth: true,
                        keepAlive: true // 用户列表需要被缓存
                    },
                    children: [...list]
                },
                {
                    path: '/changeRoom_long', //更换房间
                    name: 'ChangeRoom_long',
                    component: ChangeRoom_long,
                    menuShow: true
                },
                {
                    path: '/rentInfo_long', //租赁信息-长租
                    name: 'RentInfo_long',
                    component: RentInfo_long,
                    menuShow: true
                },
                {
                    path: '/add_bill',
                    name: 'Add_bill',
                    component: Add_bill,
                    menuShow: true
                },
                {
                    path: '/details', //订单详情
                    name: 'Details',
                    component: Details,
                    menuShow: true
                },
                {
                    path: '/more', //操作更多
                    name: 'More',
                    component: More,
                    menuShow: true
                },
                {
                    path: '/amend', //修改订单
                    name: 'Amend',
                    component: Amend,
                    menuShow: true
                },
                {
                    path: '/roomPrice-page',
                    name: 'RoomePricePage',
                    component: RoomePricePage,
                    menuShow: false
                },
                {
                    path: '/depositCut-Page',
                    name: 'depositCutPage',
                    component: depositCutPage,
                    menuShow: false
                },
                {
                    path: '/paySet-page',
                    name: 'PaySet',
                    component: PaySet,
                    menuShow: false
                },
                {
                    path: '/carNo-page',
                    name: 'carNo',
                    component: carNo,
                    menuShow: false
                },
                {
                    path: '/report',
                    name: 'Report',
                    component: Report,
                    menuShow: false
                },
                {
                    path: '/orderday',
                    component: OrderDay,
                    menuShow: false
                },
                {
                    path: '/ordermonth',
                    component: OrderMonth,
                    menuShow: false
                },
                {
                    path: '/finance',
                    name: '财务管理',
                    component: Finance,
                    menuShow: false
                },
                {
                    path: '/owner-finance',
                    name: '业主-财务管理',
                    component: OwnerFinance,
                    menuShow: false
                },
                {
                    path: '/owner-finance-rooms',
                    name: '业主-财务管理-收款详情(房间)',
                    component: OwnerFinanceRooms,
                    menuShow: false
                },
                {
                    path: '/owner-finance-details',
                    name: '业主-财务管理-收款详情(房间)',
                    component: OwnerFinanceDetails,
                    menuShow: false
                },
                {
                    path: '/owner-finance-daily-life',
                    name: '业主-财务管理-日常消耗品、保洁人工费',
                    component: OwnerFinanceDailyLife,
                    menuShow: true
                },
                {
                    path: '/handCharge',
                    name: '交账充值',
                    component: HandCharge,
                    menuShow: false
                },
                {
                    path: '/handChargeRecord',
                    name: '交账充值记录',
                    component: HandChargeRecord,
                    menuShow: false
                },
                {
                    path: '/orderDetail',
                    name: 'OrderDetail',
                    component: OrderDetail,
                    menuShow: false
                },
                {
                    path: '/moneyDetail',
                    name: 'MoneyDetail',
                    component: MoneyDetail,
                    menuShow: false
                },
                {
                    path: '/outRecord',
                    name: 'OutRecord',
                    component: OutRecord,
                    menuShow: false
                },
                {
                    path: '/dealLive',
                    name: 'DealLive',
                    component: DealLive,
                    menuShow: false
                },
                {
                    path: '/orderLive',
                    name: 'OrderLive',
                    component: OrderLive,
                    menuShow: false
                },
                {
                    path: '/dealLive_long',
                    name: 'DealLive_long',
                    component: DealLive_long,
                    menuShow: false
                },
                {
                    path: '/changeWatch',
                    name: 'ChangeWatch',
                    component: ChangeWatch,
                    menuShow: false
                },
                {
                    path: '/eleRecord',
                    name: 'EleRecord',
                    component: EleRecord,
                    menuShow: false
                },
                {
                    path: '/eleManage',
                    name: 'EleManage',
                    component: EleManage,
                    menuShow: false
                },
                {
                    path: '/eleTotal',
                    name: 'EleTotal',
                    component: EleTotal,
                    menuShow: false
                },
                // 业主模块
                {
                    path: '/owner-settle-finance',
                    name: 'OwnerSettle',
                    component: OwnerSettle,
                    menuShow: false
                },
                {
                    path: '/owner-settle-finance-person',
                    name: 'OwnerSettlePerson',
                    component: OwnerSettlePerson,
                    menuShow: false
                },
                {
                    path: '/owner-settle-finance-detail',
                    name: 'OwnerSettleDetail',
                    component: OwnerSettleDetail,
                    menuShow: false
                },
                {
                    path: '/price',
                    name: '房价',
                    component: Price,
                    menuShow: true
                },
                {
                    path: '/addOrEditHotel',
                    name: '房价',
                    component: AddOrEditHotel,
                    menuShow: true
                },
                {
                    path: '/continuePay',
                    name: 'ContinuePay',
                    component: ContinuePay,
                    menuShow: true
                },
                {
                    path: '/continuePayChoose',
                    name: 'ContinuePayChoose',
                    component: ContinuePayChoose,
                    menuShow: true
                },
                {
                    path: '/continuePay-page',
                    name: 'ContinuePayPage',
                    component: ContinuePayPage,
                    menuShow: true
                },
                {
                    path: '/normal-project',
                    name: 'NormalProject',
                    component: NormalProject,
                    menuShow: true
                },
                {
                    path: '/roomManage',
                    name: '房间管理',
                    component: RoomManage,
                    menuShow: true
                },
                {
                    path: '/addRooms',
                    name: '添加房间',
                    component: AddRooms,
                    menuShow: true
                },
                {
                    path: '/uploadHotelPic',
                    name: '上传图片',
                    component: UploadHotelPic,
                    menuShow: true
                },
                {
                    path: '/source',
                    name: '房源',
                    component: Source,
                    menuShow: true
                },
                {
                    path: '/scaleManage',
                    name: '房型管理（基础，产品，房间数量）',
                    component: ScaleManage,
                    menuShow: true
                },
                {
                    path: '/addOrEditPro',
                    name: '编辑产品房型',
                    component: AddOrEditPro,
                    menuShow: true
                },
                {
                    path: '/addPrice',
                    name: '添加费用',
                    component: AddPrice,
                    menuShow: true
                },
                {
                    path: '/state',
                    name: '房态',
                    component: State,
                    menuShow: true
                },
                {
                    path: '/statetoday',
                    name: '今日房态',
                    component: StateToday,
                    menuShow: true
                },
                {
                    path: '/stateTodayOwner',
                    name: '今日房态-业主',
                    component: StateTodayOwner,
                    menuShow: true
                },
                {
                    path: '/owner-order',
                    name: '业主-结算详情',
                    component: OwnerOrder,
                    menuShow: true
                },
                {
                    path: '/owner-order-details',
                    name: '业主-订单详情-暂时关闭页面',
                    component: OwnerOrderDetails,
                    menuShow: true
                },
                {
                    path: '/statetodayCooper',
                    name: '今日房态-cooper',
                    component: StateTodayCooper,
                    menuShow: true
                },
                {
                    path: '/stateToday_two',
                    name: '今日房态-二房东',
                    component: StateToday_two,
                    menuShow: true
                },
                {
                    path: '/rentInfo_two',
                    name: '租赁信息-二房东',
                    component: RentInfo_two,
                    menuShow: true
                },
                {
                    path: '/details_two',
                    name: '订单详情页-二房东',
                    component: Details_two,
                    menuShow: true
                },
                {
                    path: '/rentCount_two',
                    name: '退租-二房东',
                    component: RentCount_two,
                    menuShow: true
                },
                {
                    path: '/add_bill_two',
                    name: '添加生活、房费账单-二房东',
                    component: AddBillTwo,
                    menuShow: true
                },
                {
                    path: '/check_bill_two',
                    name: '添加生活、房费账单-二房东',
                    component: Check_bill_two,
                    menuShow: true
                },
                {
                    path: '/unit_details',
                    name: '添加生活、房费账单-二房东',
                    component: UnitDetails,
                    menuShow: true
                },
                {
                    path: '/apartment',
                    name: '公寓类型',
                    component: Apartment,
                    menuShow: true
                },
                {
                    path: '/room-out',
                    name: '房间支出',
                    component: RoomOut,
                    menuShow: true
                },
                {
                    path: '/pricedetail',
                    name: '日历房价',
                    component: PriceDetail,
                    props: true,
                    menuShow: false
                },
                {
                    path: '/housetype',
                    name: Housetype,
                    component: Housetype,
                    menuShow: false
                },
                {
                    path: '/relation',
                    name: Relation,
                    component: Relation,
                    menuShow: false
                },
                {
                    path: '/otaState-page',
                    name: 'OtaState',
                    component: OtaState,
                    menuShow: false
                },
                {
                    path: '/lock',
                    name: Lock,
                    component: Lock,
                    menuShow: false
                },
                {
                    path: '/reset',
                    name: Reset,
                    component: Reset,
                    menuShow: false
                },
                {
                    path: '/orderLong',
                    name: OrderLong,
                    component: OrderLong,
                    menuShow: false
                },
                {
                    path: '/resetinfo',
                    name: ResetInfo,
                    component: ResetInfo,
                    menuShow: false
                },
                {
                    path: '/focus',
                    name: Focus,
                    component: Focus,
                    menuShow: false
                },
                {
                    path: '/Police',
                    name: Police,
                    component: Police,
                    menuShow: false
                },
                {
                    path: '/hotelMember',
                    name: HotelMember,
                    component: HotelMember,
                    menuShow: false
                },
                {
                    path: '/memberDetail',
                    name: MemberDetail,
                    component: MemberDetail,
                    menuShow: false
                },
                {
                    path: '/memberSet',
                    name: MemberSet,
                    component: MemberSet,
                    menuShow: false
                },
                {
                    path: '/roomFee',
                    name: RoomFee,
                    component: RoomFee,
                    menuShow: false
                },
                {
                    path: '/roomFeeD',
                    name: RoomFeeD,
                    component: RoomFeeD,
                    menuShow: false
                },
                {
                    path: '/roomCode-page',
                    name: Roomcode,
                    component: Roomcode,
                    menuShow: false
                },
                {
                    path: '/lifeFee',
                    name: LifeFee,
                    component: LifeFee,
                    menuShow: false
                },
                {
                    path: '/lifeFeetrans',
                    name: LifeFeetrans,
                    component: LifeFeetrans,
                    menuShow: false
                },
                {
                    path: '/lifeFeeD',
                    name: LifeFeeD,
                    component: LifeFeeD,
                    menuShow: false
                },
                {
                    path: '/editLifeFee',
                    name: EditLifeFee,
                    component: EditLifeFee,
                    menuShow: false
                },
                {
                    path: '/addPerson',
                    name: AddPerson,
                    component: AddPerson,
                    menuShow: false
                },
                {
                    path: '/backRent',
                    name: BackRent,
                    component: BackRent,
                    menuShow: false
                },
                {
                    path: '/fdchange',
                    name: FdChange,
                    component: FdChange,
                    menuShow: false
                },
                {
                    path: '/quicksplit',
                    name: QuickSplit,
                    component: QuickSplit,
                    menuShow: false
                },
                {
                    path: '/quicklive',
                    name: QuickLive,
                    component: QuickLive,
                    menuShow: false
                },
                {
                    path: '/quickLiveOnline',
                    name: QuickLiveOnline,
                    component: QuickLiveOnline,
                    menuShow: false
                },
                {
                    path: '/rentCount',
                    name: RentCount,
                    component: RentCount,
                    menuShow: false
                },
                {
                    path: '/renew',
                    name: Renew,
                    component: Renew,
                    menuShow: false
                },
                {
                    path: '/stateCheck',
                    name: StateCheck,
                    component: StateCheck,
                    menuShow: false
                },
                {
                    path: '/business',
                    name: 'Business',
                    component: Business,
                    menuShow: false
                },
                {
                    path: '/business-add',
                    name: 'BusinessAdd',
                    component: BusinessAdd,
                    menuShow: false
                },
                {
                    path: '/business-allRooms',
                    name: 'BusinessAllRooms',
                    component: BusinessAllRooms,
                    menuShow: false
                },
                {
                    path: '/business-details',
                    name: 'BusinessDetails',
                    component: BusinessDetails,
                    menuShow: false
                },
                {
                    path: '/business-order',
                    name: 'BusinessOrder',
                    component: BusinessOrder,
                    menuShow: false
                },
                {
                    path: '/business-add-order',
                    name: 'BusinessAddOrder',
                    component: BusinessAddOrder,
                    menuShow: false
                },
                {
                    path: '/allBill',
                    name: 'AllBill',
                    component: AllBill,
                    menuShow: false
                },
                {
                    path: '/invoice',
                    name: 'Invoice',
                    component: Invoice,
                    menuShow: false
                },
                // 发票模块
                {
                    path: '/invoiceModel',
                    name: 'InvoiceModel',
                    component: InvoiceModel,
                    menuShow: false
                },
                // 员工管理提成
                {
                    path: '/staff',
                    name: 'Staff',
                    component: Staff,
                    menuShow: false
                },
                {
                    path: '/add-staff',
                    name: 'AddStaff',
                    component: AddStaff,
                    menuShow: false
                },
                {
                    path: '/staff-apply',
                    name: 'StaffApply',
                    component: StaffApply,
                    menuShow: false
                },
                {
                    path: '/staff-info',
                    name: 'StaffInfo',
                    component: StaffInfo,
                    menuShow: false
                },
                {
                    path: '/cleaning-task',
                    name: 'Cleaningtask',
                    component: Cleaningtask,
                    menuShow: false
                },
                // 酒店审核
                {
                    path: '/join',
                    name: 'Join',
                    component: Join,
                    menuShow: false
                },
                {
                    path: '/hotel-apply',
                    name: 'HotelApply',
                    component: HotelApply,
                    menuShow: false
                },
                {
                    path: '/add-equipment',
                    name: 'AddEquipment',
                    component: AddEquipment,
                    menuShow: false
                },
                {
                    path: '/edit-or-see-apply',
                    name: 'EditOrSeeApply',
                    component: EditOrSeeApply,
                    menuShow: false
                },
                {
                    path: '/soft-use',
                    name: 'SoftUse',
                    component: SoftUse,
                    menuShow: false
                },
                {
                    path: '/pay-page',
                    name: 'PayPage',
                    component: PayPage,
                    menuShow: false
                },
                // 智能设备
                {
                    path: '/equipment',
                    name: 'Eequipment',
                    component: Eequipment,
                    menuShow: false
                },
                {
                    path: '/add-apply',
                    name: 'AddApply',
                    component: AddApply,
                    menuShow: false
                },
                // 业务员、业务经理-客户管理
                {
                    path: '/customer-management',
                    name: 'CustomerManagement',
                    component: CustomerManagement,
                    menuShow: false
                },
                {
                    path: '/business-commission',
                    name: 'BusinessCommission',
                    component: BusinessCommission,
                    menuShow: false
                },
                {
                    path: '/commissionDetail',
                    name: 'CommissionDetail',
                    component: CommissionDetail,
                    menuShow: false
                },
                {
                    path: '/depart-management',
                    name: 'DepartManagement',
                    component: DepartManagement,
                    menuShow: false
                },
                {
                    path: '/staffDepart-management',
                    name: 'StaffDepartManagement',
                    component: StaffDepartManagement,
                    menuShow: false
                },
                {
                    path: '/staff-management',
                    name: 'StaffManagement',
                    component: StaffManagement,
                    menuShow: false
                },
                {
                    path: '/add-departStaff',
                    name: 'AddDepartStaff',
                    component: AddDepartStaff,
                    menuShow: false
                },
                {
                    path: '/business-manager',
                    name: 'BusinessManager',
                    component: BusinessManager,
                    menuShow: false
                },
                // 财务登陆模块
                // 收款确认
                {
                    path: '/finance-pay',
                    name: 'FinancePay',
                    component: FinancePay,
                    menuShow: false
                },
                {
                    path: '/finance-detail',
                    name: 'FinanceDetail',
                    component: FinanceDetail,
                    menuShow: false
                },
                // 黑名单
                {
                    path: '/black-list',
                    name: 'BlackList',
                    component: BlackList,
                    menuShow: false
                },
                // 设施管理
                {
                    path: '/roomDev',
                    name: 'RoomDev',
                    component: RoomDev,
                    menuShow: false
                },
                {
                    path: '/chooseDev',
                    name: 'ChooseDev',
                    component: ChooseDev,
                    menuShow: false
                },
                // 保洁成本设置
                {
                    path: '/cleaning',
                    name: 'Cleaning',
                    component: Cleaning,
                    menuShow: false
                },
                // 商品设置
                {
                    path: '/goods',
                    name: 'Goods',
                    component: Goods,
                    menuShow: false
                },
                // 二级商户
                {
                    path: '/merchant',
                    name: 'Merchant',
                    component: Merchant,
                    menuShow: false
                },
                {
                    path: '/merchantAddOrEdit',
                    name: 'MerchantAddOrEdit',
                    component: MerchantAddOrEdit,
                    menuShow: false
                },
                {
                    path: '/errorRoom',
                    name: 'ErrorRoom',
                    component: ErrorRoom,
                    menuShow: false
                },
                {
                    path: '/errorRooms',
                    name: 'ErrorRooms',
                    component: ErrorRooms,
                    menuShow: false
                },
            ]
        }
    ]
});
// 路由前置守卫
router.beforeEach((to, from, next) => {
    store.commit('setMenu', to.path ==
 '/dashboard');
    if (to.path ==
 '/login') {
        cookie.delCookie('access-1u2s3e4r');
        next();
    } else {
        let loged = cookie.getCookie('access-1u2s3e4r');
        if (!loged) {
            next({
                path: '/login'
            });
        } else {
            next();
        }
    }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js